import IdeyaModal from '../../../common/antd/ideya-modal.tsx'
import React, { useState } from 'react'
import IdeyaTypography from '../../../common/antd/ideya-typography.tsx'
import { Trans, useTranslation } from 'react-i18next'
import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../../redux/hooks.ts'
import Col from 'antd/es/grid/col'
import Checkbox from 'antd/es/checkbox'
import Row from 'antd/es/grid/row'
import { convertPxToNumber } from '../../../utils/helpers.ts'
import { setLocalStorageItem } from '../../../utils/local-storage.ts'
import i18n from '../../../i18n.ts'
import { IdeyaButton } from '../../../common/antd/ideya-button/ideya-button.tsx'
import { FAQ_BASE_URL } from '../../../utils/helpers.ts'

interface NewFeatureModalProps {
  open: boolean
  closeModal: () => void
}

export const NewFeatureModal: React.FC<NewFeatureModalProps> = ({
  open,
  closeModal,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false)
  const releaseNoteVersion = import.meta.env.VITE_RELEASE_NOTE_VERSION as string
  const { t } = useTranslation()
  const currentLanguage = i18n.resolvedLanguage ?? i18n.language ?? 'en'

  const faqUrlMap: Record<string, string> = {
    en: `${FAQ_BASE_URL}/en#Order-Status-and-Fill-Status`,
    jp: `${FAQ_BASE_URL}/jp#注文ステータスおよび約定ステータス`,
    tw: `${FAQ_BASE_URL}/zh-tw#訂單狀態和成交狀態`,
    cn: `${FAQ_BASE_URL}/zh-cn#订单状态和成交状态`,
  }

  const faqUrl = faqUrlMap[currentLanguage] ?? faqUrlMap.en

  const handleClose = () => {
    if (dontShowAgain) {
      setLocalStorageItem(releaseNoteVersion, { show: false })
    }

    closeModal()
  }

  return (
    <IdeyaModal
      open={open}
      isForm={false}
      title={t('release_note.new_feature_modal.title')}
      onCancel={handleClose}
      footer={
        <Row justify={'space-between'}>
          <Col>
            <Row
              gutter={convertPxToNumber(themeStyle.marginXS)}
              align={'middle'}
            >
              <Col>
                <Checkbox
                  checked={dontShowAgain}
                  onChange={(e) => setDontShowAgain(e.target.checked)}
                />
              </Col>
              <Col>
                <IdeyaTypography.Text>
                  {t('release_note.new_feature_modal.dont_show_again')}
                </IdeyaTypography.Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row gutter={convertPxToNumber(themeStyle.marginXS)}>
              <Col>
                <IdeyaButton onClick={handleClose}>
                  {t('release_note.new_feature_modal.maybe_later')}
                </IdeyaButton>
              </Col>
              <Col>
                <IdeyaButton onClick={() => window.open(faqUrl, '_blank')}>
                  {t('release_note.new_feature_modal.view_details')}
                </IdeyaButton>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    >
      <div style={{ marginBottom: themeStyle.marginBase }}>
        <IdeyaTypography.Text>
          <Trans
            i18nKey={'release_note.new_feature_modal.description'}
            components={{ bold: <b /> }}
          />
        </IdeyaTypography.Text>
        <ul
          style={{
            listStyleType: 'disc',
            paddingLeft: 20,
            marginTop: 8,
            marginBottom: 0,
          }}
        >
          <li>
            <IdeyaTypography.Text>
              {t('release_note.new_feature_modal.dashboard')}
            </IdeyaTypography.Text>
          </li>
          <li>
            <IdeyaTypography.Text>
              <Trans
                i18nKey={'release_note.new_feature_modal.idea_order_table'}
                components={{ bold: <b /> }}
              />
            </IdeyaTypography.Text>
          </li>
          <li>
            <IdeyaTypography.Text>
              {t('release_note.new_feature_modal.edit_liquidate')}
            </IdeyaTypography.Text>
          </li>
        </ul>
      </div>
      <img
        src={'https://asset.polymerideya.com/release-notes/2026-10-03.png'}
        alt={t('release_note.new_feature_modal.image_alt')}
      />
    </IdeyaModal>
  )
}
